// extracted by mini-css-extract-plugin
export default {"image":"blockContainer_image__upVL6"};